export const dayList = ['日', '一', '二', '三', '四', '五', '六']

/**
 * 格式化日期
 * @param {Date} date 日期对象
 * @param {String} format 格式字符串
 */
export function formatTime (date, format = 'YYYY-MM-DD hh:mm:ss') {
  date = new Date(date)
  const o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds()
  }
  if (/(Y+)/.test(format)) format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}

export function changeDateTab (val) {
  const date = new Date()
  if (val === '0') { // 今日
    return [date.getFullYear() + '-' + addZero(date.getMonth() + 1) + '-' + addZero(date.getDate()), date.getFullYear() + '-' + addZero(date.getMonth() + 1) + '-' + addZero(date.getDate())]
  } else if (val === '1') { // 昨日
    date.setTime(date.getTime() - 24*60*60*1000)
    return [date.getFullYear() + '-' + addZero(date.getMonth() + 1) + '-' + addZero(date.getDate()), date.getFullYear() + '-' + addZero(date.getMonth() + 1) + '-' + addZero(date.getDate())]
  } else if (val === '2') { // 本月
    return [date.getFullYear() + '-' + addZero(date.getMonth() + 1) + '-01', date.getFullYear() + '-' + addZero(date.getMonth() + 1) + '-' + addZero(date.getDate())]
  } else if (val === '3') { // 今年
    return [date.getFullYear() + '-01-01', date.getFullYear() + '-' + addZero(date.getMonth() + 1) + '-' + addZero(date.getDate())]
  } else if (val === '4') {
    return null
  }
}

function addZero (val) {
  return val < 10 ? '0' + val : val
}
